export default class CSSConstants {
    public static readonly hidden = "hidden";
    public static readonly disabled = "disabled";
    public static readonly default = "default";
    public static readonly active = "active";
    public static readonly error = "error";
    public static readonly pending = "pending";
    public static readonly warning = "warning";
    public static readonly info = "info";
    public static readonly settings = "settings";
    public static readonly list = {
        list: "list",
        element: "list-element",
        icon: "list-icon",
        title: "list-title",
        description: "list-description"
    };
}
